'use client'

import { useEffect } from 'react'

interface LocaleHtmlLangProps {
  locale: string
}

/**
 * Client component that updates the html lang attribute based on the current locale.
 * This is needed because the root layout sets a static lang="en" and nested layouts
 * need to update it dynamically based on the route locale.
 */
export function LocaleHtmlLang({ locale }: LocaleHtmlLangProps) {
  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])

  return null
}
